module.exports = __webpack_public_path__ + "img/04805994000174.a295b79f.png";